import React, { Component, Fragment } from "react";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import {
    Button,
    Grid,
    Dimmer,
    Loader,
    Container,
    Menu
} from "semantic-ui-react";
import { number, PropTypes, string } from "prop-types";
import LocationsHeader from "./LocationsHeader";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAllLocations, clearAllFilters, getRowsCountAfterFilter, deleteLocation, discardChanges, addNewLocation } from "./../../actions/locations/fetchAllLocations";
import { filterEnabledCols } from "./../../Constants/locations/filterEnabledCols";
import { showLoader } from "./../../actions/locations/showLoader";
import { isEdited } from "./../../actions/locations/isEdited";
import { saveEdits } from "./../../actions/locations/saveEdits";
import { colHeaders } from "./../../Constants/locations/colHeaders";
import { colWidths } from "./../../Constants/locations/colWidth";
import { NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_WARNING, NOTIFICATION_TYPE_ERROR } from 'react-redux-notify';
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
import MultiSelectEditor from "../../Common/MultiSelectEditor/MultiSelectEditor";
import customDropdownRenderer from "../../Common/MultiSelectEditor/CustomDrodownRender";
import DEFAULTS from "../../Constants/lookupDefaultValues";
import setDropdownValues from "../../Common/Utility/setDropdownValues";
import ConfirmationModal from "./ConfirmationModal";
import { showNotification, notificationTypes } from "../../Common/Notification/showNotification";
import { messages, hotTableLicenseKey } from "../../Constants/locations/locationConstants";
import { isNullOrEmpty } from "../../Common/Utility/helperFunctions";
import "./../../Pages/Users/Create_User/CreateUser.css"
var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}
const FIRM_ID = userDetails ? userDetails.UserContext.firmId : 0;

var placeHolders = {
    "branch_id": 0,
    "branchtype_name": "--Select--",
    "branch_name": "Enter Branch Name",
    "country_name": "--Select--",
    "location_timezone_name": "--Select--",
    "IsLocationUsed": false
};

function getFullName(UserContext) {
    var firstName = UserContext.firstName;
    var lastName = UserContext.lastName;
    var middleName = UserContext.middleName;
    var gen = UserContext.generationType;
    var fullName = lastName + ", " + firstName;
    fullName += middleName ? " " + middleName + "." : "";
    fullName += gen ? " " + gen + "." : "";
    return fullName;
}

class LocationsTable extends Component {
    filterUserStatus = false;
    columns = [];
    invalidInput = false;
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
        this.warnNotification = {
            type: NOTIFICATION_TYPE_WARNING,
            duration: 5000,
            canDismiss: true,
        }

        this.errorNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
        }
        this.succNotification = {
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
        }

        this.dummyState = {
            editedRows: [],
            updatedLocations: []
        };

        this.state = {
            mychangedRows: [],
            showPopup: false,
            isDeleteLocation: false,
            branchIdToDelete: -1,
            validationError: {
                column: "",
                isValid: true,
                value: "",
                message: ""
            }
        };

        this.settings = {
            licenseKey: hotTableLicenseKey,
            rowHeaders: true,
            manualColumnResize: true,
            filters: filterEnabledCols,
            dropdownMenu: ["filter_action_bar", "filter_by_value"],
            observeDOMVisibility: true,
            observeChanges: true,
            stretchH: "all",
            manualColumnMove: true,
            hiddenColumns: {
                columns: [0, 1, 4, 6],
                indicators: false
            },
            fillHandle: {
                direction: "vertical",
                autoInsertRow: false
            },
            columnSorting: true,
            multiColumnSorting: false,
            data: props.locations,
            headerTooltips: {
                rows: false,
                columns: true,
                onlyTrimmed: false
            }

        };
    }

    componentDidMount() {
        if (!userDetails) {
            return;
        }
        if (this.props.locations.length > 0) {
            return;
        }
        this.locations = this.props.fetchAllLocations(FIRM_ID);

        const emptyValidator = (value, callback) => {
            if (!value || 0 === value.length || value.length > 30) {
                callback(false);
            } else {
                callback(true);
            }
        };

        // code length validation
        const codeValidator = (value, callback) => {
            if (value.length <= 10) {
                callback(true);
            } else {
                callback(false);
            }
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!nextProps.locations.length) {
            return false;
        }
        if (nextProps.isAddNewLocation) {
            this.addNewLocation();
            return false;
        }

        if (nextProps.isClearFilters) {
            this.handleClearFilters();
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentWillUnmount() {
    }

    updateColumn(column) {
        if (column.selector && column.selectOptions.data == null) {
            let lookup = this.props.allLocations;
            column.selectOptions.data = setDropdownValues({
                data: lookup,
                defaults: DEFAULTS,
                selector: column.selector,
                properties: column.properties
            });
        }
    }

    runForAllCoumns() {
        this.columns.forEach(column => this.updateColumn(column));
    }
    addNewLocation = () => {
        this.clearFilters();
        this.dummyState.updatedLocations.forEach((cli, i) => {
            cli.physicalRow++;
        });
        const hotInstance = this.hotTableComponent.current.hotInstance;
        hotInstance.alter('insert_row', 0, 1);
        hotInstance.setDataAtCell(0, 0, 0);
        hotInstance.scrollViewportTo(0, 0);
        this.props.addNewLocation(false);
        this.props.getRowsCountAfterFilter(hotInstance.getData().length);
    };

    onClick = () => {
        this.props.addNewLocation(true);
    };

    onReset = () => {
    };

    ShowConfirmationPopup = () => {
        this.setState({ showPopup: true });
    }

    closeConfirmationPopup = (returngcPd) => {
        this.setState({ showPopup: false });
        this.setState({ isDeleteLocation: false });
        this.setState({ branchIdToDelete: -1 });
        if (returngcPd == 0) {
            this.setState({ disableCompletebutton: true });
        }
    }
    GetColumnData(emptyLocations) {
        var ColumnDetailData = [];
        const hot = this.hotTableComponent.current.hotInstance;
        var ColumnDetails = { "ColumnName": string, "ColIndex": number, "ChangedRow": number }

        for (let i = 0; i < emptyLocations.length; i++) {
            if (!emptyLocations[i].branch_name) {
                ColumnDetails = new Object();
                ColumnDetails.ChangedRow = emptyLocations[i].index;
                ColumnDetails.ColumnName = "branch_name";
                ColumnDetails.ColIndex = hot.propToCol(ColumnDetails.ColumnName);
                ColumnDetailData.push(ColumnDetails);
            }

            if (!emptyLocations[i].branchtype_name) {
                ColumnDetails = new Object();
                ColumnDetails.ChangedRow = emptyLocations[i].index;
                ColumnDetails.ColumnName = "branchtype_name";
                ColumnDetails.ColIndex = hot.propToCol(ColumnDetails.ColumnName);
                ColumnDetailData.push(ColumnDetails);
            }

            if (!emptyLocations[i].country_name) {
                ColumnDetails = new Object();
                ColumnDetails.ChangedRow = emptyLocations[i].index;
                ColumnDetails.ColumnName = "country_name";
                ColumnDetails.ColIndex = hot.propToCol(ColumnDetails.ColumnName);
                ColumnDetailData.push(ColumnDetails);
            }
        }
        return ColumnDetailData;
    }
    save = () => {
        var isInvalidInputExists = document.querySelectorAll('.invalidEmptyCell:not(.duplicateEntry)');
        if (isInvalidInputExists != null) {
            if (isInvalidInputExists.length > 0) {
                this.props.showNotification(messages.VALID_LOCATION_DETAILS, notificationTypes.ERROR, this.getNotificationMargin());
                return;
            }
        }
        if (this.state.locations !== undefined && this.state.locations.length > 0) {
            this.props.discardChanges();
            this.state.locations = [];
            return;
        }
        const hotInstance = this.hotTableComponent.current.hotInstance;
        const changedRows = [...new Set(this.dummyState.editedRows)];
        const updatedLocations = [...new Set(this.dummyState.updatedLocations)];
        const loc = updatedLocations;

        const changedLocations = loc
            .map((elem, i) => {
                elem.firm_id = FIRM_ID;
                elem.changedRowIndex = elem.physicalRow;
                let selectedBranchTypes = this.props.locationTypes.filter(el => el.branchtype_name === elem.branchtype_name);
                let selectedCountryCode = this.props.countries.filter(el => el.country_name === elem.country_name);
                let selectedTimezone = this.props.timeZones.filter(el => el.name === elem.location_timezone_name);
                elem.branchtype_id = changedRows.includes(elem.branch_id) && selectedBranchTypes.length > 0 ? selectedBranchTypes[0].branchtype_id : 0;
                elem.mail_country_code = changedRows.includes(elem.branch_id) && selectedCountryCode.length > 0 ? selectedCountryCode[0].country_code : 0;
                elem.location_timezone = changedRows.includes(elem.branch_id) && elem.location_timezone_name != null && elem.location_timezone_name != "" && selectedTimezone.length > 0 ? selectedTimezone[0].id : 0;
                return elem;
            })
            .filter(elem => changedRows.includes(elem.branch_id));
        let allData = hotInstance.getData();
        const allHotLocations = allData
            .map((item, index) =>
            ({
                branchtype_name: item[2],
                branch_name: item[3],
                country_name: item[5],
                index: index,
                branch_id: item[0]
            })
            )
        const emptyLocations = allHotLocations.filter(elem => isNullOrEmpty(elem.branch_name) || isNullOrEmpty(elem.branchtype_name) || isNullOrEmpty(elem.country_name));
        if (emptyLocations.length > 0) {
            var colIndexes = this.GetColumnData(emptyLocations);
            for (let i = 0; i < colIndexes.length; i++) {
                hotInstance.setCellMeta(colIndexes[i].ChangedRow, colIndexes[i].ColIndex, "className", "invalidEmptyCell ");
            }
            hotInstance.render();
            this.props.showNotification(messages.VALID_LOCATION_DETAILS, notificationTypes.ERROR, this.getNotificationMargin());
            return;
        }
        const emptyLocationsInvisible = loc.filter(elem => isNullOrEmpty(elem.branch_name) || isNullOrEmpty(elem.branchtype_name) || isNullOrEmpty(elem.country_name));
        if (emptyLocationsInvisible.length > 0) {
            this.props.showNotification(messages.VALID_LOCATION_DETAILS, notificationTypes.ERROR, this.getNotificationMargin());
            return;
        }

        const allLocations = hotInstance.getSourceData()
        for (var i = 0; i < changedLocations.length; i++) {
            var duplicateItems = allLocations.filter(elm => elm.branch_name.toUpperCase() == changedLocations[i]["branch_name"].toUpperCase());
            if (duplicateItems.length > 1) {
                const changedItem = allHotLocations.filter(y => y.branch_id == changedLocations[i]["branch_id"]);
                hotInstance.setCellMeta(changedItem[0].index, 3, "className", "invalidEmptyCell editedCellColor duplicateEntry");
                hotInstance.render();
                this.props.showNotification(messages.DUPLICATE_lOCATION_NAME, notificationTypes.ERROR, this.getNotificationMargin());
                return;
            }
        }

        const response = this.props.saveEdits(changedLocations, this.props.locations)
        response.then((res) => {
            if (res.payload.request) {
                if (res.payload.request.isSuccess) {
                    this.dummyState.editedRows = [];
                    this.dummyState.updatedLocations = [];
                    this.state.mychangedRows = [];
                    this.props.isEdited(false);
                    this.props.showNotification(messages.SAVE_SUCCESS, notificationTypes.SUCCESS);

                    this.props.fetchAllLocations(FIRM_ID).then(() => {
                        hotInstance.updateSettings(this.settings)
                        hotInstance.loadData(this.props.locations)
                        hotInstance.render();
                    });
                } else {
                    this.props.showNotification(res.payload.request.msg, notificationTypes.ERROR, this.getNotificationMargin());
                }
            }
        })
    };

    hotAfterRowMove = (rows, target) => {
        const hot = this.hotTableComponent.current.hotInstance;

        let colOrder = hot.getDataAtProp(0);
        let origLocOrder = this.props.locations.map(elem => elem.branch_id);

        this.updateMyChangedRows(rows, target);

        // columns to be set editedColor
        let setEditedClassesTo = [0, 6, 7];
        let callbackArr = [];
        colOrder.forEach((elem, index) => {
            if (elem !== origLocOrder[index]) {
                this.rowMoveData.push(hot.getSourceDataAtRow(index));
                setEditedClassesTo.map(item => {
                    if (!this.checkRowExists(index, item)) {
                        callbackArr.push({ col: item, row: index })
                    }
                });
            }
        });
        this.callback(callbackArr);
    };

    updateMyChangedRows(rows, target) {

        let dataLength = this.hotTableComponent.current.hotInstance.getData().length + 1;
        let originalRows = [...Array(dataLength).keys()];
        let reoderedRows = [];
        let direction = 'down';
        let start = 0;
        let stop = dataLength;

        if (rows.some((el) => el > target)) {
            direction = 'up';
        }
        if (direction === 'up') {
            for (let i = 0; i < dataLength; i++) {
                if (i === target) {
                    reoderedRows.splice(i, 0, ...rows, i);
                } else {
                    if (!reoderedRows.includes(i)) {
                        reoderedRows.push(i);
                    }
                }
            }
        } else {
            for (let i = dataLength - 1; i >= 0; i--) {
                if (i === target) {
                    reoderedRows.splice(i, 0, i, ...rows.reverse());
                } else {
                    if (!reoderedRows.includes(i)) {
                        reoderedRows.push(i);
                    }
                }
            }
            reoderedRows.reverse();
        }
        this.state.mychangedRows.forEach((cellObj) => {
            if (originalRows.includes(cellObj.row)) {
                cellObj.row = reoderedRows.indexOf(cellObj.row);
            }
        });
    }

    checkRowExists(row, col) {
        return this.state.mychangedRows.some((obj) => obj.row == row && obj.col == col);
    }

    tooltipRenderer(instance, td, row, col, prop, value, cellProperties, data) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            td.innerHTML = "<svg class='svg_icon xcm-icon-info orange size-20' > <title> This location cannot be deleted because \nit is associated with one or more Clients,\nTasks, Users, Groups or setup Utilities.</title><use xlink:Href =" + svg_icon_path + "#xcm-icon-info></use ></svg>"
        }
        else if (this.props.isDeleteFeatureEnabled) {
            td.innerHTML = "<div class='deleteLoc'><svg class='svg_icon xcm-icon-delete size-20'> <use xlink:Href =" + svg_icon_path + "#xcm-icon-delete></use ></svg></div>"
        }
        else {
            td.innerHTML = "<div class='deleteLoc wkusergriddisabled'><svg class='svg_icon xcm-icon-delete size-20'> <title>Delete location feature is currently offline and \nis targeted to be online with an upcoming\n post tax season product release.</title><use xlink:Href =" + svg_icon_path + "#xcm-icon-delete></use ></svg></div>"
        }
    }

    callback(data) {
        if (!data) {
            return;
        }
        if (data && typeof data === "object") {
            this.state.mychangedRows.push(...data);
        }
    }

    afterFilterHandler(conditionsStack) {
        if (this.hotTableComponent.current === null) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        let afterFilterRowsCount = hot.getData().length;
        this.props.getRowsCountAfterFilter(afterFilterRowsCount);
        this.filterUserStatus = false;
        const showFilter = document.querySelector('.xcm-icon-filter-clear');
        if (showFilter != null) {
            showFilter.style.visibility = 'visible';
        }
    }

    afterLoadDataHandler(initialLoad) {
        if (
            !this.props.locations.length ||
            this.hotTableComponent.current === null
        ) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        if (this.filterUserStatus) {
            var filterPlugin = hot.getPlugin("Filters");
            filterPlugin.addCondition(10, "by_value", [["Active"]]);
            filterPlugin.filter();
        }
    }
    afterGetColHeaderHandler(col, TH) {
        if (col > 7) {
            const button = TH.querySelector('.changeType');
            if (!button) {
                return;
            }
            button.parentElement.removeChild(button);
        }
        var editableFields = [1, 2, 3, 4, 5, 7];
        if (editableFields.includes(col)) {
            TH.classList.add("editable");
        }
        return;
    }

    afterOnCellMouseDownHandler(event, cellCoords, TD) {
        const hotInstance = this.hotTableComponent.current.hotInstance;
        var colNo = hotInstance.propToCol("IsLocationUsed");
        if (cellCoords.col === colNo && !this.props.isDeleteFeatureEnabled) return;
        if (this.hotTableComponent.current == null) return;
        if (cellCoords.row < 0) return;

        let selectedRow = hotInstance.getSourceDataAtRow(hotInstance.toPhysicalRow(cellCoords.row));
        //To remove empty rows.
        if (cellCoords.col === colNo && selectedRow.branch_id === 0) {
            hotInstance.alter("remove_row", cellCoords.row, 1);
            return;
        }

        if (cellCoords.col === colNo && !selectedRow.IsLocationUsed && selectedRow.branch_id > 0) {
            this.setState({ isDeleteLocation: true });
            this.setState({ branchIdToDelete: selectedRow.branch_id });
            this.ShowConfirmationPopup();
        }
    }

    deleteLocationOnConfirmation = async () => {
        this.props.showLoader(true);
        const hotRef = this.hotTableComponent.current.hotInstance;
        const request = await this.props.deleteLocation(this.state.branchIdToDelete);

        if (request.payload.requestDelete) {
            this.props.showLoader(false);
            if (request.payload.requestDelete.isSuccess) {
                let data = hotRef.getSourceData();
                let index = data.indexOf(data.find(p => p.branch_id == this.state.branchIdToDelete))
                hotRef.alter("remove_row", index, 1);

                this.props.fetchAllLocations(FIRM_ID).then(() => {
                    hotRef.render();
                    this.props.showNotification(messages.DELETE_SUCCESS, notificationTypes.SUCCESS);
                });
            }
            else {
                this.props.showNotification(request.payload.requestDelete.msg, notificationTypes.WARNING);
            }
        }
        this.closeConfirmationPopup();
    }

    handleHOTChangeBefore = (changes, sources) => {
        if (sources == "ContextMenu.rowBelow") {
            return;
        }
        if (sources !== "edit" && sources !== "Autofill.fill") {
            return;
        }
        if (sources == "Autofill.fill" && changes[0][1] == 'branchtype_name' && changes[0][3] == 'Main Office') {

            changes.forEach(elem => elem[3] = elem[2]);
            this.props.showNotification(messages.UNIQUE_MAIN_OFFICE, notificationTypes.ERROR);
            return;
        }
        // if there is no change then there is no need to validate
        if (changes[0][2] === changes[0][3]) {
            return;
        }

        switch (changes[0][1]) {

            case 'branchtype_name':
                const countOfMain = this.props.locations.filter(
                    elem => elem.branchtype_name == 'Main Office'
                ).length;
                if (countOfMain >= 1 && changes[0][3] == 'Main Office') {
                    changes[0][3] = changes[0][2];
                    this.props.showNotification(messages.UNIQUE_MAIN_OFFICE, notificationTypes.ERROR, this.getNotificationMargin());
                    return;
                }

                break;

            case 'branch_name':
                this.updateLocs(changes, changes[0][1]);
                break;
        }

    };

    updateLocs(changes, type) {
        if (changes[0][3] == "") {
            changes[0][3] = changes[0][2]
            this.props.showNotification(`${changes[0][1] === "branch_name" ? "Branch name" : ""} should not be empty.`, notificationTypes.ERROR);
        }

        // validation for name 100 characters limit 

        else if (type === "branch_name" && changes[0][3].length > 100) {
            changes[0][3] = changes[0][2]
            this.props.showNotification(messages.BRANCH_NAME_MAX_LENGTH, notificationTypes.ERROR);
        }


        // length & special characters validation - replaces to old value incase invalid entry
        if (type === "branch_name" ? !(/^([a-zA-Z0-9_/\-]+( [a-zA-Z0-9_/\-]+)*)$/.test(changes[0][3])) : !(/^([a-zA-Z0-9_-]){1,10}$/.test(changes[0][3]))) {

            var warningMessage = "";
            warningMessage = "Branch name should not contain special character."

            changes[0][3] = changes[0][2]
            this.props.showNotification(`${warningMessage}`, notificationTypes.ERROR);
        }
    }

    handleHOTChange = (changes, sources) => {
        if (changes === null || this.hotTableComponent.current === null || sources === "loadData" || sources === "ObserveChanges.change" || changes[0][2] === changes[0][3]) { return; }
        if (sources === "edit" || sources === "Autofill.fill") {
            const hot = this.hotTableComponent.current.hotInstance;

            changes.map(element => {
                let changedLocationId = hot.getDataAtRow(element[0])[0] ?? 0;
                let changedRowIndex = element[0];
                let physicalRow = hot.toPhysicalRow(changedRowIndex);
                let updatedLocationData = hot.getSourceDataAtRow(physicalRow);
                updatedLocationData.physicalRow = physicalRow;
                let index = this.dummyState.updatedLocations.findIndex(
                    loc => loc.branch_id == updatedLocationData.branch_id && loc.physicalRow == updatedLocationData.physicalRow
                );

                if (index >= 0) {
                    this.dummyState.updatedLocations.splice(index, 1);
                }

                this.dummyState.updatedLocations.push({ ...updatedLocationData });

                if (!this.dummyState.editedRows.includes(changedLocationId)) {
                    this.dummyState.editedRows.push(changedLocationId);
                }
                let changedColIndex = hot.propToCol(element[1]);
                if (element[2] !== element[3]) {
                    if (this.props.edited != true) {
                        this.props.isEdited(true);
                    }
                    var className = "editedCellColor";
                    if (this.invalidInput) { className += " invalidEmptyCell"; }
                    hot.setCellMeta(
                        changedRowIndex,
                        changedColIndex,
                        "className",
                        className
                    );
                    hot.render();
                }
            });
        }
    };


    discardChangesOnYes = () => {
        this.RemoveEmptyRow();
        this.props.discardChanges();
        this.dummyState.editedRows = [];
        this.dummyState.updatedLocations = [];
        this.props.showNotification(messages.DISCARD_SUCCESS, notificationTypes.SUCCESS);
        this.closeConfirmationPopup();
    }


    showLoader(bool) {
        if (bool) {
            return (
                <Dimmer active inverted>
                    <Loader inverted>Loading</Loader>
                </Dimmer>
            );
        }
    }

    clearFilters() {
        this.props.clearAllFilters(true, this.props.locations);

    }
    handleClearFilters() {
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
        this.props.clearAllFilters(false, this.props.locations);
        hot.loadData(this.props.locations);
        hot.render();
    }

    RemoveEmptyRow() {
        const hotInstance = this.hotTableComponent.current.hotInstance;
        var rowCount = hotInstance.countRows();
        for (var i = rowCount - 1; i >= 0; i--) {
            if (hotInstance.getDataAtCell(i, 0) == null || hotInstance.getDataAtCell(i, 0) == 0) {
                hotInstance.alter('remove_row', i, 1);
            }
        }
    }


    showAddLocationBtn() {
        return (
            <Button
                primary
                title="Add Location"
                onClick={this.onClick}
            >  <svg className={`svg_icon xcm-icon-plus size-20`}>
                    <use xlinkHref={`${svg_icon_path}#xcm-icon-plus`}> </use>
                </svg>Add Location
            </Button>
        );
    }
    getNotificationMargin() {
        return this.props.edited ? "6%" : null;
    }
    render() {

        this.columns = [
            {
                data: "branch_id",
                type: "text",
                readOnly: true
            },
            {
                data: "branchtype_id",
                type: "dropdown",
                source: this.props.locationTypes.map(element => {
                    return element.branchtype_id;
                }),
                allowInvalid: false
            },
            {
                data: "branchtype_name",
                type: "dropdown",
                placeholder: placeHolders.branchtype_name,
                readOnly: false,
                source: this.props.locationTypes.map(element => {
                    return element.branchtype_name;
                }),
                allowInvalid: false
            },
            {
                data: "branch_name",
                type: "text",
                placeholder: placeHolders.branch_name,
                readOnly: false,
                allowEmpty: false,
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
            },

            {
                data: "mail_country_code",
                type: "dropdown",
                source: this.props.countries.map(element => {
                    return element.country_code;
                }),
                allowInvalid: false

            },

            {

                data: "country_name",
                type: "dropdown",
                placeholder: placeHolders.country_name,
                source: this.props.countries.map(element => {
                    return element.country_name;
                }),
                allowInvalid: false,

            },
            {

                data: "location_timezone",
                type: "dropdown",
                placeholder: placeHolders.location_timezone_name,
                source: this.props.timeZones.map(element => {
                    return element.id;
                }),
                allowInvalid: false
            },
            {

                data: "location_timezone_name",
                placeholder: placeHolders.location_timezone_name,
                allowInvalid: false,
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selector: "timeZones",
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }
            },
            {
                data: "IsLocationUsed",
                renderer: this.tooltipRenderer.bind(this),
                readOnly: false,
                editor: false,
                allowHtml: true
            }

        ];
        if (Object.keys(this.props.allLocations.timeZones).length) {
            this.runForAllCoumns();
        }
        return (
            <Fragment>
                <ConfirmationModal
                    showPopup={this.state.showPopup}
                    closePopup={this.closeConfirmationPopup}
                    discardChangesYes={this.discardChangesOnYes}
                    isDeleteLocation={this.state.isDeleteLocation}
                    deleteLocation={this.deleteLocationOnConfirmation}
                />
                <Container fluid>
                    {this.props.shouldShowLoader ? (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    ) : (
                        <div />
                    )}

                    <div id="hot-app">
                        <Grid>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Menu secondary className="mt-6 mb-8">
                                        <Menu.Item>
                                            <LocationsHeader />
                                        </Menu.Item>
                                        <Menu.Menu position="right">
                                            {this.props.rowsCount != this.props.locations.length ? (
                                                <Menu.Item>
                                                    <svg className={`svg_icon xcm-icon-filter-clear size-24 visibilityHidden`}
                                                        onClick={this.clearFilters.bind(this)}>
                                                        <title> Clear Filters </title>
                                                        <use xlinkHref={`${svg_icon_path}#xcm-icon-filter-clear`}> </use>
                                                    </svg>
                                                </Menu.Item>
                                            ) : ("")}

                                            <Menu.Item>
                                                {this.showAddLocationBtn()}
                                            </Menu.Item>
                                        </Menu.Menu>
                                    </Menu>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid >
                    </div >
                    {

                        this.props.locations.length >= 1 ? (
                            <HotTable
                                id="locationsHot"
                                ref={this.hotTableComponent}
                                settings={this.settings}
                                data={this.props.locations}
                                width="100%"
                                height="calc(100vh - 130px)"
                                colHeaders={colHeaders}
                                colWidths={colWidths}
                                columns={this.columns}
                                afterGetColHeader={this.afterGetColHeaderHandler}
                                afterOnCellMouseDown={this.afterOnCellMouseDownHandler.bind(this)}
                                afterGetRowHeader={this.afterGetRowHeaderHandler}
                                afterFilter={this.afterFilterHandler.bind(this)}
                                afterChange={(changes, source) =>
                                    this.handleHOTChange(changes, source)
                                }
                                beforeChange={(changes, source) => {
                                    this.handleHOTChangeBefore(changes, source);
                                }}
                                afterRowMove={(rows, target) =>
                                    this.hotAfterRowMove(rows, target)
                                }
                                // this is for prevention of page error issue when click delete / backspace on a cell
                                beforeKeyDown={(event) => {
                                    if (event.keyCode === 46 || event.keyCode === 8) {
                                        event.stopImmediatePropagation()
                                    }
                                }}
                                stretchH="all"
                                className="ml-4"
                            />
                        ) : (
                            <Dimmer active inverted>
                                <Loader inverted>Loading</Loader>
                            </Dimmer>
                        )
                    }

                    <div id="buttons" className="mt-6">
                        {this.props.edited ? (
                            <Grid padded textAlign="right">
                                <Grid.Row columns={2}>
                                    <Grid.Column textAlign="left">
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Button
                                            onClick={() => this.ShowConfirmationPopup()}>Cancel</Button>
                                        <Button primary onClick={this.save} title="Save Edit">
                                            Save
                                        </Button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        ) : <span />}
                    </div>

                </Container>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {

    return {
        locations: state.allLocations.locations,
        timeZones: state.allLocations.timeZones,
        countries: state.allLocations.countries,
        locationTypes: state.allLocations.locationTypes,
        rowsCount: state.allLocations.rowsCount,
        isClearFilters: state.allLocations.isClearFilters,
        shouldShowLoader: state.allLocations.showLoader,
        edited: state.allLocations.edited,
        allLocations: state.allLocations,
        isAddNewLocation: state.allLocations.isAddNewLocation,
        isDeleteFeatureEnabled: state.allLocations.isDeleteFeatureEnabled
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchAllLocations,
            clearAllFilters,
            getRowsCountAfterFilter,
            discardChanges,
            deleteLocation,
            showLoader,
            isEdited,
            saveEdits,
            showNotification,
            addNewLocation
        },
        dispatch
    );
}


LocationsTable.propTypes = {
    locations: PropTypes.arrayOf(
        PropTypes.shape({
            branchtype_id: PropTypes.number,
            branchtype_name: PropTypes.string,
            branch_id: PropTypes.number,
            branch_name: PropTypes.string,
            mail_country_code: PropTypes.string,
            country_name: PropTypes.string,
            location_timezone: PropTypes.number,
            location_timezone_name: PropTypes.string,
            IsLocationUsed: PropTypes.bool
        })
    ),
    timeZones: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    ),
    countries: PropTypes.arrayOf(
        PropTypes.shape({
            country_code: PropTypes.string,
            country_name: PropTypes.string
        })
    ),
    locationTypes: PropTypes.arrayOf(
        PropTypes.shape({
            branchtype_id: PropTypes.number,
            branchtype_name: PropTypes.string
        })
    ),
    rowsCount: PropTypes.number,
    edited: PropTypes.bool,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocationsTable);


